import React from 'react'
import ShuffleHero from './Hero'
import AboutSection from './About'
import Example from './Carousel'
import Footer from './Footer'

const HomePage = () => {
  return (
    <div>
      <ShuffleHero/>
      <AboutSection/>
      <Example/>
      <Footer/>
    </div>
  )
}

export default HomePage
